import { useState, useEffect } from 'react';
import { Modal } from 'flowbite-react';
import { Button } from 'modules/v2/common/AtomicDesign/atoms';

const STORAGE_KEY = 'mhub_dont_show_bridge';

const customTheme = {
  root: {
    show: {
      on: 'flex bg-gray-700 bg-opacity-50',
      off: 'hidden',
    },
  },
  content: {
    base: 'relative h-full w-full max-w-lg md:h-auto',
  },
};

const LaunchModal = ({ show, onContinue, onClose }) => {
  const [dontShow, setDontShow] = useState(false);

  // Reset checkbox when modal reopens (component stays mounted)
  useEffect(() => {
    if (show) setDontShow(false);
  }, [show]);

  const handleContinue = () => {
    if (dontShow) {
      localStorage.setItem(STORAGE_KEY, 'true');
    }
    onContinue();
  };

  return (
    <Modal
      className="font-figtree"
      theme={customTheme}
      show={show}
      onClose={onClose}
      size="lg"
    >
      <Modal.Body>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-neutral-900">Set up your Marketing Hub</h3>
          <button
            type="button"
            onClick={onClose}
            className="text-neutral-400 hover:text-neutral-600"
            aria-label="Close"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="space-y-4 text-sm text-neutral-700">
          <p>
            The Marketing Hub is{' '}
            <span className="font-bold">
              a marketplace of outreach tools connected to your Authorify account
            </span>
            . Use it to mail follow-up postcards and letters, schedule social media posts, send
            automated email campaigns, and more.
          </p>

          <div>
            <p className="font-semibold mb-2">Here&apos;s how it works:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Your Authorify plan may already include select services</li>
              <li>
                If your plan includes mail-on-demand or other campaigns, we&apos;ve provisioned your
                account with complimentary credits
              </li>
              <li>You only pay if you choose to go beyond what&apos;s included</li>
            </ul>
          </div>

          <div>
            <p className="font-semibold mb-1">Why am I being asked to add a card?</p>
            <p>
              Some tools run on third-party platforms. Adding a card connects your account so you can
              choose to use additional services when needed.
            </p>
          </div>

          <p className="text-neutral-500 text-xs">
            The Marketing Hub is currently in testing. Your support team can help you get set up.
          </p>

          <label className="flex items-center gap-2 cursor-pointer select-none pt-2">
            <input
              type="checkbox"
              checked={dontShow}
              onChange={(e) => setDontShow(e.target.checked)}
              className="h-4 w-4 rounded border-neutral-300 text-primary-500 focus:ring-primary-500"
            />
            <span className="text-sm text-neutral-700">
              I understand — don&apos;t show this message again
            </span>
          </label>
        </div>

        <div className="flex justify-end mt-6">
          <Button type="primary" onClick={handleContinue}>
            Continue
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export { STORAGE_KEY };
export default LaunchModal;
